import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueScreen from "vue-screen";
import VueHead from "vue-head";
import VueResizeText from "vue-resize-text";
import createRouter from "./router";

import App from "./App.vue";

import store from "./store";

// Vue.config.productionTip = false;

const VueScrollTo = require("vue-scrollto");

Vue.use(VueHead);
Vue.use(BootstrapVue);
Vue.use(VueScreen);
Vue.use(VueAxios, axios);
Vue.use(VueScrollTo);
Vue.use(VueResizeText);

Vue.component("app", App);

(async () => {
  const router = typeof createRouter === "function" ? await createRouter({ Vue }) : createRouter;

  router.afterEach((to, from) => {
    document.body.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  return new Vue({
    el: "#app",
    store,
    router,
    App,
    render: h => h(App)
  });
})();
